import Promise from 'bluebird';
import { servletSave } from './helpers';

export default class SupportMessageDAO {
  constructor(urls) {
    this.CONTACT_US_URL = urls.CONTACT_US_URL;
  }

  save({ contactName, contactEmail, contactPhone, issueDescription }) {
    if (typeof contactEmail !== 'string' || contactEmail.trim().length === 0) {
      return Promise.reject(new Error('Contact E-mail is required!'));
    }
    if (typeof contactName !== 'string' || contactName.trim().length === 0) {
      return Promise.reject(new Error('Contact name is required!'));
    }
    if (typeof issueDescription !== 'string' || issueDescription.trim().length === 0) {
      return Promise.reject(new Error('Issue description is required!'));
    }

    return servletSave(this.CONTACT_US_URL, { contactName, contactEmail, contactPhone, issueDescription });
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/SupportMessageDAO.js